import React, { FC } from 'react';
import { InlineFaqsPanelType } from '../../../models/inline-faqs-panel-type';
import { InlineFaqsType } from '../../../models/inline-faqs-type';
import Accordion from '../../molecules/accordion/accordion';
import RichText from '../../molecules/rich-text/rich-text';

const InlineFaqs: FC<InlineFaqsType> = ({ faqItems }: InlineFaqsType) => (
  <div className="py-component-spacing-mobile lg:py-component-spacing-content mx-auto w-full md:w-10/12 lg:w-8/12">
    <Accordion
      items={faqItems.map((item: InlineFaqsPanelType) => ({
        heading: item.heading,
        body: <RichText>{item.description}</RichText>,
      }))}
    />
  </div>
);

export default InlineFaqs;
